import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { currencyFormat, dateFormatterForUS } from '../../../utils/formatHelper';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';
import { REPORT_TYPES } from './consts';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { hideRefundTotalWhenNotRefunded } from '../../../constants/featureFlag';

export function ReturnsTableRow(props) {
  const { row } = props;
  const { visibleColumns } = useSelector((state) => state.analytics.reports[REPORT_TYPES.RETURNS]);

  const shouldHideTotalRefundWhenNotRefunded = useFeatureFlag(hideRefundTotalWhenNotRefunded, false, true);
  const currentGmv = row.gmv[row.currency];
  const pricePerItem = currentGmv.returns / row.returnedUnits;
  const isRefunded = row.returnLineStatus === 'accepted';
  const totalRefund = currentGmv.returns;
  let totalRefundFormatted = currencyFormat(totalRefund, row.currency);

  if (shouldHideTotalRefundWhenNotRefunded && !isRefunded) {
    totalRefundFormatted = '-';
  }

  return (
    <tr>
      <td>{row.returnedDate ? dateFormatterForUS(row.returnedDate) : NO_VALUE_PLACEHOLDER}</td>
      <td>{dateFormatterForUS(row.orderCreatedDate)}</td>
      <td>{row.retailerName}</td>
      <td>{row.countryName}</td>
      {visibleColumns.includes('returnCode') && <td>{row.returnCode ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('returnReason') && <td>{row.returnReason ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('retailerOrderId') && <td>{row.retailerOrderId}</td>}
      {visibleColumns.includes('salesOrderNumber') && <td>{row.salesOrderNumber}</td>}
      {visibleColumns.includes('sku') && <td>{row.identifiers.sku ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('upc') && <td>{row.identifiers.upc ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('ean') && <td>{row.identifiers.ean ?? NO_VALUE_PLACEHOLDER}</td>}
      {visibleColumns.includes('model') && <td>{row.model}</td>}
      {visibleColumns.includes('productName') && <td>{row.productName}</td>}
      {visibleColumns.includes('unitsCount') && <td>{row.orderedUnits}</td>}
      {visibleColumns.includes('returnedUnits') && <td>{row.returnedUnits}</td>}
      {visibleColumns.includes('refunded') && <td>{isRefunded ? 'Yes' : 'No'}</td>}
      {visibleColumns.includes('pricePerItem') && <td>{currencyFormat(pricePerItem, row.currency)}</td>}
      {visibleColumns.includes('totalRefund') && <td>{totalRefundFormatted}</td>}
      {visibleColumns.includes('orderType') && <td>{row.orderType ?? NO_VALUE_PLACEHOLDER}</td>}
    </tr>
  );
}

ReturnsTableRow.propTypes = {
  row: PropTypes.object.isRequired,
};
